module.exports = __webpack_public_path__ + "img/SKMJ_install2.ab6b3eef.png";